import { render, staticRenderFns } from "./SubMenu.vue?vue&type=template&id=55780fe2&functional=true&"
import script from "./SubMenu.vue?vue&type=script&lang=ts&"
export * from "./SubMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports